import React from 'react';
import "../../styles/chats/reaction_bubble.css";

const ReactionBubble = ({isReactionBubbleShow, reaction}) => {
    return(
        <div className={`reaction_bubble_dialog ${isReactionBubbleShow ? "show" : ""}`}>
            <p>{reaction}</p>
        </div>
    );
};

export default ReactionBubble;